import React, {useEffect, useState, useContext} from 'react';
import axios from 'axios';
import classes from './NewsEventsDetailPage.module.scss';
import {Helmet} from "react-helmet";
import {HomeBreadcrumb} from "../../../components/UI/HomeButton";
import {Link} from "react-router-dom";
import JIcon from "../../../components/UI/Icon/JIcon";
import scrollToComponent from "react-scroll-to-component";
import ReactGa from "react-ga";
import DateIcon from "../../../components/UI/DateComponent/DateIcon";
import AuthorInfo from "../../../components/UI/AuthorInfo/AuthorInfo";
import {LoadingSimple} from "../../../components/UI/LoadingBar";
import {Context} from "../../../context/Wrapper";
import {FormattedMessage} from "react-intl";
import {LANG_ID} from "../../../constants";

const NewsEventsDetailPage = (props) => {
    const context = useContext(Context)

    const [state, setState] = useState({
        isLoading: false
        , my_list: []
        , selected_data: []
    });

    const [categoriesId] = useState([
        {id: 'News', value: 'Berita'},
        {id: 'Events', value: 'Kegiatan'}
    ])

    useEffect(() => {
        //============================================
        // console.log('useEffect 1');
        //============================================
        //add by hendra on 14 oct 2020
        ReactGa.pageview(window.location.origin.toString() + props.location.pathname);
        const loadDocumentTitle = () => {
            document.title = localStorage.getItem('news_events:selected_detail') !== null ?
                localStorage.getItem('news_events:selected_detail') &&
                localStorage.getItem('news_events:selected_detail').concat(" | Japfa Food | Indonesian | Food Supplier")
                :
                "News Events Detail | Japfa Food | Indonesian | Food Supplier"
        }
        window.scrollTo(0, 0);

        const fetchData = async () => {
            setState({...state, isLoading: true})
            const header = {headers: {'language': context.locale}};
            const getData_1 = await axios.get('news_event/' + props.match.params.id, header);
            console.log('getData_1', getData_1);
            setState({
                ...state,
                selected_data: getData_1.data,
                isLoading: false
            });
        }
        try {
            fetchData()
            loadDocumentTitle();
        } catch (e) {

        }
        //eslint-disable-next-line
    }, [props.location.pathname, props.history, props.match.params.id, context.locale]);

    let tempMetaDesc = '';
    let metaDesc = '';
    if (state.selected_data.content !== undefined) {
        tempMetaDesc = state.selected_data.content.replace(/(<([^>]+)>)/ig, "");
        metaDesc = tempMetaDesc.length > 150 ? tempMetaDesc.substr(0, 150).trim() : tempMetaDesc.trim();
    }

    return (
        <>
            <div className={["violet", classes.NewsEventsDetailPage_container].join(' ')} ref={(section) => {
                scrollToComponent.Violet = section;
            }}>

                <Helmet>
                    <meta name="description" content={metaDesc}/>
                    <meta name="keywords" content={"frozen food, meat shop, Chicken shop, supplier frozen food, food service, Best Chicken, Tokusen, Omayo, food catering, food service delivery, Japfa Indonesia, food solutions, JBFS, Food Supplier"}/>
                    <meta name="author" content=""/>
                    <meta property="og:title"
                          content={state.selected_data.title &&
                          state.selected_data.title.concat(" | Japfa Food | Indonesia | Food Supplier")}/>
                    <meta property="og:description"
                          content={"JAPFA FOOD: " + metaDesc}/>
                    <title>{
                        localStorage.getItem('news_events:selected_detail') &&
                        `${localStorage.getItem('news_events:selected_detail')}${(" | Japfa Food | Indonesian | Food Supplier")}`
                    }</title>

                    <link rel="canonical" href={window.location.origin.toString() + props.location.pathname}/>
                </Helmet>

                {/*Bread crumbs region*/}
                <section className={[classes.NewsEventsDetailPage_sectionBread].join(' ')}>
                    <div className={["jbfs-wrapper", classes.NewsEventsDetailPage_wrapperBread].join(' ')}>
                        <div className={["jbfs-breadcrumb-row",].join(' ')}>
                            <HomeBreadcrumb/>
                            <span>/</span><Link to={'/news-events/'}><FormattedMessage id={"newsevents.title"} defaultMessage={"News & Events"}/></Link>
                            <span>/</span>
                            <div>{state.selected_data && state.selected_data.title}</div>
                        </div>
                    </div>
                </section>
                {/*Bread crumbs region*/}

                <section className={classes.NewsEventsDetailPage_sectionHeader}>
                    <div className={["jbfs-wrapper", classes.NewsEventsDetailPage_wrapperHeader].join(' ')}>
                        <div>
                            <h1 className={"jbfs-title-case"}>
                                {state.selected_data.category &&
                                context.locale === LANG_ID ? categoriesId.filter(x => x.id === state.selected_data.category)[0].value : state.selected_data.category
                                }
                            </h1>
                        </div>
                    </div>
                </section>

                <section className={classes.NewsEventsDetailPage_sectionContent}>
                    <div className={["jbfs-wrapper", classes.NewsEventsDetailPage_wrapperContent].join(' ')}>
                        <div className={classes.WrapperContent_card}>
                            <div className={classes.ImageHero_row}>
                                {state.selected_data && state.selected_data < 1 ? (<LoadingSimple/>) : (
                                    <div style={{backgroundImage: `url(${(state.selected_data.image)})`}}/>
                                )}
                            </div>
                            <div className={classes.Content_row}>
                                {state.selected_data && state.selected_data < 1 ? <LoadingSimple position={"left"}/> : (
                                    <>
                                        <DateIcon classMy={classes.Date_component} created_on={state.selected_data.created_on}/>

                                        <div className={classes.Content_wrapper}>
                                            <h2 dangerouslySetInnerHTML={{__html: (state.selected_data.title)}}/>
                                            <div className={classes.Auth_Info}>
                                                <AuthorInfo created_on={state.selected_data.created_on} created_by={state.selected_data.created_by}/>
                                            </div>
                                            <div className={classes.Description} dangerouslySetInnerHTML={{__html: (state.selected_data.content)}}/>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className={["jbfs-goto-top-button",].join(' ')} hidden>
                <JIcon icontype={"link_to_top"}
                       onClick={() => scrollToComponent(scrollToComponent.Violet, {offset: -99, align: 'top', duration: 1500})}/>
            </div>
        </>
    )
}

export default NewsEventsDetailPage